import { render, staticRenderFns } from "./StammdatenImportPage.vue?vue&type=template&id=2867aedf&scoped=true&"
import script from "./StammdatenImportPage.vue?vue&type=script&lang=js&"
export * from "./StammdatenImportPage.vue?vue&type=script&lang=js&"
import style0 from "./StammdatenImportPage.vue?vue&type=style&index=0&id=2867aedf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/zeitkontrolle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2867aedf",
  null
  
)

export default component.exports